<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>重要提醒</el-breadcrumb-item>
      <el-breadcrumb-item>异常提醒</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.loginname" @keyup.enter.native="clicksearch" placeholder="请输入登录名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <Rsljigou :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-date-picker v-model="keywords.begintime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" class="mr15"></el-date-picker>
          <el-date-picker v-model="keywords.endtime" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" class="mr15"></el-date-picker>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <el-button type="primary" @click="clickexcel" v-if="SubRule_ExcelExceptionReminder">导出Excel</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询 end -->

        <el-table v-loading="loading" :data="dataList" border stripe>
          <el-table-column prop="Loginname" label="登录名称" width="120px" ></el-table-column>
          <el-table-column prop="Name" label="用户姓名" width="120px"></el-table-column>
          <el-table-column prop="Jigouname" label="归属机构"></el-table-column>
          <el-table-column label="第一次报警">
            <template slot-scope="scope">
              <span v-if="scope.row.Firstwarn === 0" style="color: #05bb74;">{{ scope.row.Firstwarns }}</span>
              <span v-if="scope.row.Firstwarn === 1" style="color: #e95d4e;">{{ scope.row.Firstwarns }}</span>
            </template>
          </el-table-column>
          <el-table-column label="第二次报警">
            <template slot-scope="scope">
              <span v-if="scope.row.Secondwarn === 0" style="color: #05bb74;">{{ scope.row.Secondwarns }}</span>
              <span v-if="scope.row.Secondwarn === 1" style="color: #e95d4e;">{{ scope.row.Secondwarns }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Lessthan180s" label="佩戴总时长">
            <template slot-scope="scope">
              <span v-if="scope.row.Lessthan180 === 0" style="color: #05bb74;">{{ scope.row.Lessthan180s }}</span>
              <span v-if="scope.row.Lessthan180 === 1" style="color: #e95d4e;">{{ scope.row.Lessthan180s }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Lessthan120s" label="看近时长">
            <template slot-scope="scope">
              <span v-if="scope.row.Lessthan120 === 0" style="color: #05bb74;">{{ scope.row.Lessthan120s }}</span>
              <span v-if="scope.row.Lessthan120 === 1" style="color: #e95d4e;">{{ scope.row.Lessthan120s }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Morethan30s" label="异常总时长">
            <template slot-scope="scope">
              <span v-if="scope.row.Morethan30 === 0" style="color: #05bb74;">{{ scope.row.Morethan30s }}</span>
              <span v-if="scope.row.Morethan30 === 1" style="color: #e95d4e;">{{ scope.row.Morethan30s }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Tongjitime" label="统计日期"></el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->
    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou
  },
  name: 'MyExceptionReminder',
  data () {
    return {
      loading: false,
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      keywords: {
        loginname: '',
        jigouid: '-1',
        jigouname: '',
        begintime: '',
        endtime: ''
      },
      SubRule_ExcelExceptionReminder: false
    }
  },
  mounted () {
    this.apiExceptionRemindernum()
    this.apiExceptionReminderlist()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_ExcelExceptionReminder', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ExcelExceptionReminder = true
      }
    })
  },
  methods: {
    changeRsljigou (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiExceptionReminderlist()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiExceptionRemindernum()
      this.apiExceptionReminderlist()
    },
    clickexcel () {
      this.apiExcelExceptionReminder()
    },
    apiExceptionReminderlist: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        loginname: that.keywords.loginname,
        jigouid: that.keywords.jigouid,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExceptionReminderlist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiExceptionRemindernum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        loginname: that.keywords.loginname,
        jigouid: that.keywords.jigouid,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExceptionRemindernum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelExceptionReminder: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        loginname: that.keywords.loginname,
        jigouid: that.keywords.jigouid,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelExceptionReminder, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
